import comLogic from './Logic'
import comInput from './Input'
import comOperand from './Logic_Operand'

export default {

    props: ['type', 'rule', 'value'],

    components: {
        'com-logic': comLogic,
        'com-input': comInput,
        'com-operand': comOperand
    },

    data: function() {
        
        return {
            noOperand: false,
            model: {},
            options: []
        }
        
    },
    
    created: function() {

        if (this.$_.keys(this.value).length) {

            this.$_.each(this.value, function(value, key) {

                if (this.model[key] !== undefined) this.model[key] = value

            }.bind(this))

            if(this.noOperand && !this.$_.contains(['='], this.model.operand)) this.model.operand = '='

        }
        
        if(!this.$_.contains(this.options, this.model.operand) && !this.noOperand) this.model.operand = this.options[0]

        this.$emit('input', this.$util.copy(this.model))

    },

    computed: {

        unit: function() {

            return this.type.lang.unit

        }

    },
    
    watch: {

        value: {

            deep: true,

            handler: function(n) {

                if (!this.$_.isEqual(n, this.model)) {
                    
                    this.model = this.$util.copy(n)

                }

            }

        },

        model: {

            deep: true,

            handler: function(n) {

                if (!this.$_.isEqual(n, this.value)) {

                    this.$emit('input', this.$util.copy(n))

                }

            }
            
        }

    }

}